/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

function FestivalInterlagos2024MotosRedirect({ posts, categories }) {
  const router = useRouter();
  useEffect(() => {
    router.replace(`/blog/festival-interlagos-carros.html${window.location.search}`);
  }, []);
  return <>{/*  */}</>;
}

export const config = {
  amp: false,
};

export async function getStaticProps() {
  return {
    props: {},
  };
}

export default FestivalInterlagos2024MotosRedirect;
